(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulse-main-product"] && !Shopify.designMode) return;
  try {
    
  class PulsePdp extends HTMLElement {
    connectedCallback() {
      this._variantInput = this.querySelector('[data-ppd-variant-id]');
      this._priceEl      = this.querySelector('[data-ppd-price]');
      this._stageImg     = this.querySelector('.ppd-stage-img');
      this._flavourEl    = this.querySelector('[data-ppd-flavour]');
      this._atcBtn       = this.querySelector('[data-ppd-atc]');
      this._qtyInput     = this.querySelector('[data-ppd-qty]');
      this._chips        = [...this.querySelectorAll('.ppd-chip')];
      this._thumbs       = [...this.querySelectorAll('.ppd-thumb')];
      this._specsEl      = this.querySelector('[data-ppd-specs]');
      this._specCells    = [1, 2, 3, 4].map(n => ({
        row: this.querySelector(`[data-ppd-spec="${n}"]`),
        val: this.querySelector(`[data-ppd-spec-value="${n}"]`),
        lbl: this.querySelector(`[data-ppd-spec-label="${n}"]`)
      }));
      this._ingrDetails  = this.querySelector('[data-ppd-ingr-details]');
      this._ingrBody     = this.querySelector('[data-ppd-ingr-body]');
      this._servingEl    = this.querySelector('[data-ppd-serving]');
      this._nutriEl      = this.querySelector('[data-ppd-nutri]');
      this._fallbackImg  = this.dataset.fallbackImg || '';
      this._i18n = {
        qtyLess: this.dataset.i18nQtyLess || 'Fewer',
        qtyMore: this.dataset.i18nQtyMore || 'More',
        soldOut: this.dataset.i18nSoldOut || 'Sold out'
      };

      const raw = this.querySelector('[data-ppd-variants]');
      this._variants = raw ? JSON.parse(raw.textContent) : [];

      this._chips.forEach(chip => {
        chip.addEventListener('click', () => {
          const id = parseInt(chip.dataset.variantId, 10);
          this._selectVariant(id, chip);
        });
      });

      this._thumbsEl = this.querySelector('[data-ppd-thumbs]');

      this._thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => this._setStageImage(i));
      });

      // SSR rendered the gallery correctly for the initial variant — no JS rebuild needed on load.

      const dec = this.querySelector('[data-ppd-dec]');
      const inc = this.querySelector('[data-ppd-inc]');
      if (dec) dec.addEventListener('click', () => this._changeQty(-1));
      if (inc) inc.addEventListener('click', () => this._changeQty(1));

      if (this._qtyInput) {
        this._qtyInput.addEventListener('change', () => {
          const v = Math.max(1, parseInt(this._qtyInput.value, 10) || 1);
          this._qtyInput.value = v;
        });
      }

      // Refs for stepper state management
      this._qtyWrapper = this.querySelector('.ppd-qty');
      this._buyRow     = this.querySelector('.ppd-buy-row');

      // Build stepper once; inject as last child of buy-row
      var _escAttr = function(s) { return String(s).replace(/"/g, '&quot;'); };
      this._stepper = document.createElement('div');
      this._stepper.className = 'ppd-stepper';
      this._stepper.innerHTML =
        '<button class="ppd-stepper__btn ppd-stepper__dec" type="button" aria-label="' + _escAttr(this._i18n.qtyLess) + '">−</button>' +
        '<span class="ppd-stepper__qty-val">1</span>' +
        '<button class="ppd-stepper__btn ppd-stepper__inc" type="button" aria-label="' + _escAttr(this._i18n.qtyMore) + '">+</button>';
      if (this._buyRow) this._buyRow.appendChild(this._stepper);

      this._stepperDecBtn = this._stepper.querySelector('.ppd-stepper__dec');
      this._stepperIncBtn = this._stepper.querySelector('.ppd-stepper__inc');
      this._stepperQtyEl  = this._stepper.querySelector('.ppd-stepper__qty-val');

      this._cartVariantId  = null;
      this._cartLineKey    = null;
      this._stepperPending = false;
      this._atcRevertTimer = null;
      this._cartByVariant  = {};

      this._stepperDecBtn.addEventListener('click', () => this._stepperChange(-1));
      this._stepperIncBtn.addEventListener('click', () => this._stepperChange(+1));

      // Prevent native form submit unconditionally — cart type = Page → redirect
      const form = this.querySelector('.ppd-form');
      if (form) form.addEventListener('submit', e => e.preventDefault());

      if (this._atcBtn) {
        this._atcBtn.addEventListener('click', e => {
          e.preventDefault();
          this._handleAtc();
        });
      }

      // Load cart state; set initial buy-row UI for the SSR-selected variant
      const _cartUrl = (window.routes.cart_url || '/cart') + '.js';
      fetch(_cartUrl)
        .then(r => r.json())
        .then(cart => {
          (cart.items || []).forEach(item => {
            this._cartByVariant[Number(item.id)] = { key: item.key, quantity: item.quantity };
          });
          this._applyCartState(
            parseInt(this._variantInput ? this._variantInput.value : '0', 10)
          );
        })
        .catch(() => {
          this._applyCartState(
            parseInt(this._variantInput ? this._variantInput.value : '0', 10)
          );
        });
    }

    _handleAtc() {
      const btn = this._atcBtn;
      if (!btn || btn.disabled) return;

      clearTimeout(this._atcRevertTimer);

      const addUrl    = window.routes.cart_add_url || '/cart/add.js';
      const vid       = parseInt(this._variantInput ? this._variantInput.value : '0', 10);
      const qty       = parseInt(this._qtyInput     ? this._qtyInput.value     : '1', 10) || 1;
      const labelOrig = btn.dataset.labelAvailable || btn.textContent.trim();

      btn.disabled = true;

      const _errRevert = (errLabel) => {
        btn.textContent = errLabel;
        btn.disabled    = false;
        this._atcRevertTimer = setTimeout(() => { btn.textContent = labelOrig; }, 2000);
      };

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: vid, quantity: qty,
          sections: ['cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      })
        .then(r => r.json())
        .then(data => {
          if (data.status) {
            // data.errors can be an object/array — never assign directly to textContent
            _errRevert(typeof data.description === 'string'
              ? data.description
              : (btn.dataset.labelSoldOut || this._i18n.soldOut));
            return;
          }
          this._patchBubble(data);
          this._cartByVariant[Number(vid)] = { key: data.key, quantity: data.quantity };
          this._cartVariantId = Number(vid);
          this._cartLineKey   = data.key;
          this._showStepper(data.quantity);
        })
        .catch(() => _errRevert(btn.dataset.labelSoldOut || this._i18n.soldOut));
    }

    _showStepper(qty) {
      const measured = this._atcBtn
        ? Math.round(this._atcBtn.getBoundingClientRect().width)
        : 0;
      const btnW = (measured > 40) ? measured : 220;

      if (this._qtyWrapper) this._qtyWrapper.style.display = 'none';
      if (this._atcBtn)     this._atcBtn.style.display     = 'none';

      if (this._stepperQtyEl) this._stepperQtyEl.textContent = qty;
      this._stepper.style.width = Math.round(btnW * 1.3) + 'px';
      this._stepper.classList.add('is-visible');

      // Ensure a fresh stepper is never stuck disabled from a prior cycle
      this._stepperPending = false;
      this._setStepperDisabled(false);
    }

    _showDefault() {
      if (this._stepper)    this._stepper.classList.remove('is-visible');
      if (this._qtyWrapper) this._qtyWrapper.style.display = '';
      if (this._atcBtn) {
        this._atcBtn.style.display = '';
        this._atcBtn.disabled      = false;
      }
      if (this._qtyInput) this._qtyInput.value = '1';
      this._setStepperDisabled(false);
      this._cartVariantId = null;
      this._cartLineKey   = null;
      // _cartByVariant intentionally preserved — map survives UI resets
    }

    _applyCartState(vid) {
      vid = Number(vid);
      const entry = this._cartByVariant[vid];
      if (entry) {
        this._cartVariantId = vid;
        this._cartLineKey   = entry.key;
        this._showStepper(entry.quantity);
      } else {
        this._showDefault();
      }
    }

    _stepperChange(delta) {
      if (this._stepperPending) return;

      const changeUrl = window.routes.cart_change_url
        || (window.routes.cart_url ? window.routes.cart_url + '/change.js' : '/cart/change.js');
      const current = parseInt(this._stepperQtyEl ? this._stepperQtyEl.textContent : '1', 10) || 1;
      const next    = current + delta;

      if (next <= 0) {
        if (!this._cartLineKey) { this._showDefault(); return; }
        this._stepperPending = true;
        this._setStepperDisabled(true);

        fetch(changeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: this._cartLineKey, quantity: 0,
            sections: ['cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        })
          .then(r => r.json())
          .then(data => {
            this._stepperPending = false;
            this._cartByVariant = {};
            (data.items || []).forEach(item => {
              this._cartByVariant[Number(item.id)] = { key: item.key, quantity: item.quantity };
            });
            this._patchBubble(data);
            this._showDefault();
          })
          .catch(() => {
            this._stepperPending = false;
            this._setStepperDisabled(false);
          });
        return;
      }

      // Optimistic update
      if (this._stepperQtyEl) this._stepperQtyEl.textContent = next;
      this._stepperPending = true;
      this._setStepperDisabled(true);

      fetch(changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: this._cartLineKey, quantity: next,
          sections: ['cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      })
        .then(r => r.json())
        .then(data => {
          this._stepperPending = false;
          this._setStepperDisabled(false);
          if (data.status || data.errors) {
            if (this._stepperQtyEl) this._stepperQtyEl.textContent = current;
            return;
          }
          this._cartByVariant = {};
          (data.items || []).forEach(item => {
            this._cartByVariant[Number(item.id)] = { key: item.key, quantity: item.quantity };
          });
          this._patchBubble(data);
          // Sync from authoritative cart — handles Shopify inventory clamping
          const entry = this._cartByVariant[this._cartVariantId];
          if (entry && this._stepperQtyEl) this._stepperQtyEl.textContent = entry.quantity;
        })
        .catch(() => {
          this._stepperPending = false;
          this._setStepperDisabled(false);
          if (this._stepperQtyEl) this._stepperQtyEl.textContent = current;
        });
    }

    _setStepperDisabled(val) {
      if (this._stepperDecBtn) this._stepperDecBtn.disabled = val;
      if (this._stepperIncBtn) this._stepperIncBtn.disabled = val;
    }

    _patchBubble(data) {
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && data.sections && data.sections['cart-icon-bubble']) {
        const doc  = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
        const node = doc.querySelector('.shopify-section');
        if (node) bubble.innerHTML = node.innerHTML;
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pulse-pdp', cartData: data });
      }
    }

    _selectVariant(id, clickedChip) {
      this._applyCartState(id);
      const variant = this._variants.find(v => v.id === id);
      if (!variant) return;

      if (this._variantInput) this._variantInput.value = id;

      this._chips.forEach(c => {
        const active = parseInt(c.dataset.variantId, 10) === id;
        c.classList.toggle('active', active);
        c.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      if (this._priceEl) {
        this._priceEl.classList.toggle('price--on-sale', !!variant.compareAtPrice);
        this._priceEl.innerHTML =
          '<div class="price__regular"><span class="price-item price-item--regular">' + variant.price + '</span></div>' +
          '<div class="price__sale"><s class="price-item price-item--regular">' + (variant.compareAtPrice || '') + '</s>' +
          '<span class="price-item price-item--sale price-item--last">' + variant.price + '</span></div>';
      }

      if (this._flavourEl) {
        const name = variant.flavourName || (variant.title !== 'Default Title' ? variant.title : '');
        if (name) {
          this._flavourEl.textContent = name;
          this._flavourEl.hidden = false;
        } else {
          this._flavourEl.hidden = true;
        }
      }

      if (this._atcBtn) {
        this._atcBtn.disabled = !variant.available;
        this._atcBtn.textContent = variant.available
          ? this._atcBtn.dataset.labelAvailable
          : this._atcBtn.dataset.labelSoldOut;
      }

      const accColor = variant.acc    || '#15151a';
      const accInk   = variant.accInk || '#ffffff';
      this.style.setProperty('--pp-acc',     accColor);
      this.style.setProperty('--pp-acc-ink', accInk);
      document.querySelectorAll('.ppir-sec, .ppb-sec, .pphu-sec').forEach(function(el) {
        el.style.setProperty('--pp-acc',     accColor);
        el.style.setProperty('--pp-acc-ink', accInk);
      });

      this._rebuildGallery(variant.images || []);

      // Ingredients accordion
      if (this._ingrDetails) this._ingrDetails.hidden = !variant.ingredients;
      if (this._ingrBody) this._ingrBody.innerHTML = variant.ingredients
        ? variant.ingredients.replace(/\n/g, '<br>')
        : '';

      // Serving instructions
      if (this._servingEl) {
        this._servingEl.textContent = variant.servingInstr || '';
        this._servingEl.hidden      = !variant.servingInstr;
      }

      // Nutrition table
      if (this._nutriEl) {
        this._nutriEl.innerHTML = this._renderNutritionRows(variant.nutritionRows || '');
      }

      // Update spec strip
      if (variant.specs && this._specCells) {
        let hasAny = false;
        variant.specs.forEach((spec, i) => {
          const cell = this._specCells[i];
          if (!cell) return;
          if (cell.val) cell.val.textContent = spec.val || '';
          if (cell.lbl) cell.lbl.textContent = spec.lbl || '';
          if (cell.row) cell.row.hidden = !spec.val;
          if (spec.val) hasAny = true;
        });
        if (this._specsEl) this._specsEl.hidden = !hasAny;
      }

      // Update URL so the selected variant is shareable and survives refresh
      const url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      history.replaceState({}, '', url.toString());
    }

    _rebuildGallery(images) {
      var self = this;

      // Update main stage immediately
      var src0 = (images && images.length > 0) ? images[0] : this._fallbackImg;
      if (src0 && this._stageImg) {
        this._stageImg.classList.add('ppd-fading');
        setTimeout(function() {
          self._stageImg.removeAttribute('srcset');
          self._stageImg.src = src0;
          self._stageImg.classList.remove('ppd-fading');
        }, 200);
      }

      // Locate (or create) the thumbnail container
      var thumbsEl = this._thumbsEl;
      if (!thumbsEl) {
        thumbsEl = document.createElement('div');
        thumbsEl.setAttribute('data-ppd-thumbs', '');
        thumbsEl.className = 'ppd-thumbs';
        var galleryEl = this.querySelector('.ppd-gallery');
        if (galleryEl) galleryEl.appendChild(thumbsEl);
        this._thumbsEl = thumbsEl;
      }

      // Wipe old listeners by clearing _thumbs before innerHTML replacement
      this._thumbs = [];

      if (!images || images.length <= 1) {
        thumbsEl.hidden = true;
        thumbsEl.innerHTML = '';
        return;
      }

      thumbsEl.hidden = false;
      thumbsEl.innerHTML = images.map(function(src, i) {
        var esc = src.replace(/"/g, '&quot;');
        return '<button class="ppd-thumb' + (i === 0 ? ' active' : '') + '" type="button" data-full-src="' + esc + '">' +
          '<img src="' + esc + '" loading="lazy" alt="" style="max-width:100%;height:auto;display:block;">' +
          '</button>';
      }).join('');

      this._thumbs = Array.from(thumbsEl.querySelectorAll('.ppd-thumb'));
      this._thumbs.forEach(function(thumb, i) {
        thumb.addEventListener('click', function() { self._setStageImage(i); });
      });
    }

    _renderNutritionRows(raw) {
      if (!raw || !raw.trim()) return '';
      const esc = s => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      let rows = '';
      for (const line of raw.split('\n')) {
        const lt = line.replace(/\r/g, '').trim();
        if (!lt) {
          rows += '<tr class="ppd-nutri-divider"><td colspan="3"></td></tr>';
        } else if (lt[0] === '#') {
          const hcols = lt.slice(1).trim().split('|').map(s => s.trim());
          rows += '<tr class="ppd-nutri-hdr"><th></th>';
          hcols.forEach(h => { rows += `<th>${esc(h)}</th>`; });
          rows += '</tr>';
        } else {
          const cols = lt.split('|').map(s => s.trim());
          if (cols.length >= 3) {
            rows += `<tr><td class="lbl">${esc(cols[0])}</td><td class="val">${esc(cols[1])}</td><td class="val">${esc(cols[2])}</td></tr>`;
          } else {
            rows += `<tr><td class="lbl">${esc(cols[0])}</td><td class="val" colspan="2">${esc(cols[1] || '')}</td></tr>`;
          }
        }
      }
      return rows ? `<table class="ppd-nutri-table"><tbody>${rows}</tbody></table>` : '';
    }

    _setStageImage(idx) {
      this._thumbs.forEach((t, i) => t.classList.toggle('active', i === idx));
      const thumb = this._thumbs[idx];
      if (!thumb || !this._stageImg) return;
      const src = thumb.dataset.fullSrc;
      if (!src) return;
      this._stageImg.classList.add('ppd-fading');
      setTimeout(() => {
        this._stageImg.removeAttribute('srcset');
        this._stageImg.src = src;
        this._stageImg.classList.remove('ppd-fading');
      }, 200);
    }

    _changeQty(delta) {
      if (!this._qtyInput) return;
      const current = parseInt(this._qtyInput.value, 10) || 1;
      this._qtyInput.value = Math.max(1, current + delta);
    }
  }

  if (!customElements.get('pulse-pdp')) {
    customElements.define('pulse-pdp', PulsePdp);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulse-newest"] && !Shopify.designMode) return;
  try {
    
  class NewestProduct extends HTMLElement {
    connectedCallback() {
      this._prods = [...this.querySelectorAll(':scope > script[type="application/json"]')]
        .map(s => { try { return JSON.parse(s.textContent); } catch (e) { return null; } })
        .filter(Boolean);

      if (!this._prods.length) return;

      this._idx = 0;

      const prev = this.querySelector('.ppn-prev');
      const next = this.querySelector('.ppn-next');
      if (prev) prev.addEventListener('click', () => {
        this._rotate((this._idx - 1 + this._prods.length) % this._prods.length);
      });
      if (next) next.addEventListener('click', () => {
        this._rotate((this._idx + 1) % this._prods.length);
      });

      // Wire initial accent; SSR'd text/image are already correct
      this._syncAccent();
    }

    _rotate(idx) {
      const img = this.querySelector('.ppn-stage-img');
      if (img) img.style.opacity = '0';

      setTimeout(() => {
        this._idx = idx;
        this._syncText();
        this._syncImage();
        this._syncAccent();
        if (img) img.style.opacity = '1';
      }, 300);
    }

    _syncAccent() {
      const p = this._prods[this._idx];
      if (!p) return;
      this.style.setProperty('--pp-acc',     p.accent     || '#15151a');
      this.style.setProperty('--pp-acc-ink', p.accent_ink || '#fff');
    }

    _syncText() {
      const p = this._prods[this._idx];
      if (!p) return;

      const set = (sel, val) => {
        const el = this.querySelector(sel);
        if (el) el.textContent = val || '';
      };

      set('.ppn-title-1', p.title1);
      set('.ppn-title-2', p.title2);
      set('.ppn-type',    p.type_label);

      for (let n = 1; n <= 3; n++) {
        const lv = p['usp' + n + '_label'] || '';
        const dv = p['usp' + n + '_desc']  || '';
        set('.ppn-usp-label[data-n="' + n + '"]', lv);
        set('.ppn-usp-desc[data-n="'  + n + '"]', dv);
        const row = this.querySelector('.ppn-usp[data-n="' + n + '"]');
        if (row) row.hidden = !lv && !dv;
      }

      const cta = this.querySelector('.ppn-cta');
      if (cta) {
        if (p.url) { cta.href = p.url; cta.hidden = false; }
        else { cta.hidden = true; }
      }
    }

    _syncImage() {
      const p   = this._prods[this._idx];
      const img = this.querySelector('.ppn-stage-img');
      if (!img || !p || !p.image_url) return;
      img.src = p.image_url;
      img.alt = p.image_alt || '';
    }
  }

  if (!customElements.get('newest-product')) {
    customElements.define('newest-product', NewestProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulse-spotlight"] && !Shopify.designMode) return;
  try {
    
class SpotlightCarousel extends HTMLElement {
  connectedCallback() {
    this.act   = 0;
    this.items = Array.from(this.querySelectorAll('.pps-item'));
    this.dots  = Array.from(this.querySelectorAll('.pps-dot'));

    this.nameEl    = this.querySelector('.pps-name');
    this.flavEl    = this.querySelector('.pps-flav');
    this.typeEl    = this.querySelector('.pps-type');
    this.priceEl   = this.querySelector('.pps-price');
    this.atcEl     = this.querySelector('.pps-atc');
    this.currentUrl = '{{ init_variant_url }}';

    this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i)));

    // Clicking a non-active item centres it; clicking the active item navigates to its PDP
    // _dragged flag (set by pointer handler) suppresses the click that follows a swipe
    this.items.forEach((el, i) => {
      el.addEventListener('click', (e) => {
        if (this._dragged) { e.preventDefault(); return; }
        if (i !== this.act) {
          this.go(i);
        } else {
          if (e.target.tagName === 'IMG') {
            const url = this.currentUrl;
            if (url && url !== '#') window.location.href = url;
          }
        }
      });
    });

    // Keyboard nav
    this.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft')  this.rotate(-1);
      if (e.key === 'ArrowRight') this.rotate(1);
    });

    // Horizontal trackpad / mouse-wheel nav
    let wheelLock = false;
    this.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && Math.abs(e.deltaX) > 12) {
        e.preventDefault();
        if (wheelLock) return;
        wheelLock = true;
        if (e.deltaX > 0) this.go(Math.min(this.act + 1, this.items.length - 1));
        else               this.go(Math.max(this.act - 1, 0));
        setTimeout(() => { wheelLock = false; }, 350);
      }
    }, { passive: false });

    // Pointer/touch drag nav (mouse + finger)
    let dragStartX = null, dragStartY = null;
    this._dragged = false;
    this.addEventListener('pointerdown', (e) => {
      dragStartX = e.clientX;
      dragStartY = e.clientY;
      this._dragged = false;
    });
    this.addEventListener('pointerup', (e) => {
      if (dragStartX === null) return;
      const dx = e.clientX - dragStartX;
      const dy = e.clientY - dragStartY;
      // Only navigate if the swipe is mostly horizontal and past threshold
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        this._dragged = true;              // click fires after pointerup — flag suppresses it
        if (dx < 0) this.go(Math.min(this.act + 1, this.items.length - 1));
        else         this.go(Math.max(this.act - 1, 0));
      }
      dragStartX = null;
      dragStartY = null;
    });
    this.addEventListener('pointercancel', () => { dragStartX = null; dragStartY = null; });

    this.render();
  }

  rotate(dir) {
    this.act = (this.act + dir + this.items.length) % this.items.length;
    this.render();
  }

  go(i) {
    this.act = i;
    this.render();
  }

  render() {
    var n   = this.items.length;
    var act = this.act;

    var POS = { '-2': 'pL2', '-1': 'pL1', '0': 'p0', '1': 'pR1', '2': 'pR2' };

    this.items.forEach(function(el, i) {
      var rel = ((i - act) % n + n) % n;
      if (rel > n / 2) rel -= n;
      var cls = POS[String(rel)];
      el.className = 'pps-item' + (cls ? ' ' + cls : '');
      if (!cls) el.style.opacity = '0';
      else       el.style.removeProperty('opacity');
    });

    var data = JSON.parse(
      this.items[this.act].querySelector('script[type="application/json"]').textContent
    );

    var acc    = data.acc    || '#15151a';
    var accInk = data.accInk || '#15151a';

    this.style.setProperty('--pp-acc',     acc);
    this.style.setProperty('--pp-acc-ink', accInk);

    if (this.nameEl)  this.nameEl.textContent  = data.name    || '';
    if (this.flavEl)  this.flavEl.textContent  = data.flavour || '';
    if (this.typeEl)  this.typeEl.textContent  = data.type    || '';
    if (this.priceEl) this.priceEl.textContent = data.price   || '';

    this.currentUrl = data.url || '#';

    if (this.atcEl) {
      var newVid = data.variantId;
      this.atcEl.dataset.variantId = newVid || '';
      this.atcEl.classList.toggle('is-blocked', !!data.blocked);

      // Clear sold-out message when switching slides
      var soldOutEl = this.atcEl.querySelector('.pps-sold-out');
      if (soldOutEl) soldOutEl.textContent = '';

      // Sync button/stepper state from cart items cache (set by pulse-quick-add.js)
      var cartItems = window._ppsCartItems || [];
      var cartItem  = null;
      for (var ci = 0; ci < cartItems.length; ci++) {
        if (cartItems[ci].variant_id === newVid) { cartItem = cartItems[ci]; break; }
      }
      if (cartItem) {
        this.atcEl.classList.add('is-in-cart');
        var qtyEl = this.atcEl.querySelector('.ppt-stepper__qty');
        if (qtyEl) qtyEl.textContent = cartItem.quantity;
        this.atcEl.dataset.lineKey = cartItem.key;
      } else {
        this.atcEl.classList.remove('is-in-cart');
        var addBtn = this.atcEl.querySelector('.ppt-btn--add');
        if (addBtn) addBtn.disabled = false;
        delete this.atcEl.dataset.lineKey;
      }
    }

    this.dots.forEach(function(d, i) {
      var on = (i === act);
      d.classList.toggle('on', on);
      d.setAttribute('aria-selected', String(on));
    });
  }
}

if (!customElements.get('spotlight-carousel')) {
  customElements.define('spotlight-carousel', SpotlightCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulse-trending"] && !Shopify.designMode) return;
  try {
    
class TrendingRow extends HTMLElement {
  connectedCallback() {
    var row  = this.querySelector('.ppt-scroll');
    var prev = this.querySelector('.ppt-prev');
    var next = this.querySelector('.ppt-next');
    // Scroll by one card (296px) + one gap (18px) per click
    var step = 314;

    if (prev) prev.addEventListener('click', function() {
      row.scrollBy({ left: -step, behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function() {
      row.scrollBy({ left: step, behavior: 'smooth' });
    });
  }
}

if (!customElements.get('trending-row')) {
  customElements.define('trending-row', TrendingRow);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulse-ugc"] && !Shopify.designMode) return;
  try {
    
  class UgcRow extends HTMLElement {
    connectedCallback() {
      const scroller = this.querySelector('.ppu-scroll');
      const dots     = [...this.querySelectorAll('.ppu-dots i')];
      const cards    = [...this.querySelectorAll('.ppu-card:not(.ppu-follow)')];
      if (!scroller || !dots.length || !cards.length) return;

      let ticking = false;

      scroller.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          const cardW = (cards[0].getBoundingClientRect().width || 250) + 14;
          const idx   = Math.min(
            Math.round(scroller.scrollLeft / cardW),
            dots.length - 1
          );
          dots.forEach((d, i) => d.classList.toggle('on', i === idx));
          ticking = false;
        });
      }, { passive: true });
    }
  }

  if (!customElements.get('ugc-row')) {
    customElements.define('ugc-row', UgcRow);
  }

  } catch(e) { console.error(e); }
})();
})();
